export default `\
  // empty
`;
